import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { filterViewableAttrs } from "../attribute/filterViewableAttrs";
import { makeAttrColumn } from "../attribute/makeAttrColumn";
import { ZSpecification } from "../specification";
import { columnDisplayId, sysColumnsHistory } from "../sysData/sysColumns";
import { ZValueCatalogCardSafe } from "./ZValueCatalogCard";

export const buildValueCatalogColumns = (
  spec: ZSpecification,
): RtColumn<ZValueCatalogCardSafe>[] => [
  columnDisplayId,
  ...filterViewableAttrs(spec.definition?.attributes ?? []).map((attr) =>
    makeAttrColumn(attr, spec.name),
  ),
  ...sysColumnsHistory,
];
